export default __webpack_public_path__ + "static/media/submit.671351dc.svg";